/**
 * Created by ianandersen on 4/6/17.
 */
/**
 * Created by ianandersen on 4/6/17.
 */

import React from 'react';
import Description from './FileProperties/Description';
import Download from './FileProperties/Download';
import RelatedFiles from './FileProperties/RelatedFiles';
import Series from './FileProperties/Series';
import Subtitle from './FileProperties/Subtitle';
import Tags from './FileProperties/Tags';
import Title from './FileProperties/Title';
import Thumbnail from './FileProperties/Thumbnail';
import Author from './FileProperties/Author';
import ShareButtons from 'Views/ShareButtons';

class OtherView extends React.Component {
  constructor(props) {
    super(props);
    this.file = props.file;
  }

  render() {
    let file = this.file;
    return (
      <div
        className="container"
        style={{height: '100%', width: '100%', padding: '0'}}
      >
        <div
          style={{
            paddingLeft: '15px',
            paddingRight: '15px',
            paddingTop: '20px',
            verticalAlign: 'middle'
          }}
        >
          <div className="col-md-2">
            <Thumbnail file={file} />
          </div>
          <div className="col-md-2">
            <Title text={file.get('title')} />
            <Subtitle text={file.get('subtitle')} />
            <Author text={file.get('author')} />
            <Description
              style={{marginTop: '10px'}}
              text={file.get('description')}
            />
          </div>
          <div className="col-md-2">
            {file.isDownloadable() ? <div style={{textAlign: 'center', marginTop: '20px'}}>
              <Download
                file={file}
                name={file.get('title') + '.' + file.get('extension')}
                url={file.downloadLink}
              />
            </div> : null}
          </div>
          <div className="col-md-2">
            <RelatedFiles files={file.get('related_files')} />
          </div>
          <div className="col-md-2">
            <Series series={file.get('media_series')} />
          </div>
          <div className="col-md-2">
            <Tags file={file} />
          </div>
          <div className="col-md-12">
            {this.props.social.url ? (
              <ShareButtons {...this.props.social} />
            ) : (
              <ShareButtons {...this.props.social} url={window.location.href} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default OtherView;
